export default "__VITE_ASSET__3jRwowzl__ 480w, __VITE_ASSET__Mpr2lEEx__ 768w, __VITE_ASSET__DZ8Mg$xh__ 1200w, __VITE_ASSET__BrABxLQK__ 1920w";